import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.varios)
      ? (_openBlock(), _createBlock(_component_a_select, {
          key: 0,
          class: "ss-tamanho-completo",
          onChange: _ctx.change,
          value: _ctx.computedRecursosSelecionados,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedRecursosSelecionados) = $event)),
          "show-search": "",
          mode: "multiple",
          allowClear: true,
          placeholder: _ctx.props.placeholder,
          optionFilterProp: "label",
          options: _ctx.state.listaRecursos,
          disabled: (_ctx.props.disabled || _ctx.state.listaRecursos.length === 1)
        }, null, 8, ["onChange", "value", "placeholder", "options", "disabled"]))
      : (_openBlock(), _createBlock(_component_a_select, {
          key: 1,
          class: "ss-tamanho-completo",
          onChange: _ctx.change,
          value: _ctx.computedRecursoSelecionado,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedRecursoSelecionado) = $event)),
          "show-search": "",
          allowClear: true,
          placeholder: _ctx.props.placeholder,
          optionFilterProp: "label",
          options: _ctx.state.listaRecursos,
          disabled: (_ctx.props.disabled || _ctx.state.listaRecursos.length === 1)
        }, null, 8, ["onChange", "value", "placeholder", "options", "disabled"]))
  ]))
}